import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { CrudlStatus } from "../../../common/config/AppConstants";
import {
  ViewState,
  ValidateState,
  ToggleState
} from "../../../common/config/AppConstants";
import * as format from "../../../common/FormatFunctions";
import { ToolsDisplay } from "./ToolsDisplay";

export class ToolsTable extends React.Component {
  export = () => {
    this.dt.exportCSV();
  };

  getStationColumns = () => {
    console.log(this.props);
    var allColumns = [];
    // allColumns.push(
    //   <pr.Column
    //     key="expander"
    //     expander={true}
    //     style={{ width: "5em", float: "middle" }}
    //   />
    // );
    if (format.isNotNull(this.props.tableColumns)) {
      let columns = this.props.tableColumns.map((col, i) => {
        return (
          <pr.Column
            key={col.field}
            field={col.field}
            header={col.header}
            sortable={col.sortable}
            filter={col.filter}
            filterMatchMode={col.filterMatchMode}
            style={col.style}
          />
        );
      });

      columns.forEach(e => {
        allColumns.push(e);
      });
    }
    return allColumns;
  };

  render() {
    return (
      <React.Fragment>
        <div className="ui-g-12">
          <pr.BreadCrumb
            model={this.props.menuState}
            home={pr.getBreadcrumbMenuHome()}
            style={{
              backgroundColor: "lightgrey",
              color: "black"
            }}
          />
        </div>
        <div className="ui-g-12">
          <div className="ui-g-12 ui-md-6 ui-lg-3">
            <div className="content-section">
              <div className="feature-intro">
                <h1>{"Stations"}</h1>
                <p>{"A collection of all Stations"}</p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="ui-g-12"
          style={
            this.props.settingsToggle === ToggleState.ON
              ? {}
              : { display: "none" }
          }
        >
          <div className="ui-g-6">
            <h3>Table Columns</h3>
            <pr.MultiSelect
              value={this.props.tableColumns}
              options={this.props.columnOptions}
              onChange={this.props.columnToggle}
              style={{
                width: "100%",
                algin: "middle"
              }}
            />
          </div>
          <div className="ui-g-6">
            <h3>Table Rows</h3>
            <pr.Dropdown
              value={this.props.rowCount || ""}
              options={[
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 25, value: 25 },
                { label: 50, value: 50 },
                { label: 75, value: 75 },
                { label: 100, value: 100 }
              ]}
              onChange={e => {
                console.log(e);
                this.props.updateState("rowCount", e.value);
              }}
              style={{ width: "100%" }}
            />
          </div>
        </div>
        <div className="ui-g-12">
          <pr.DataTable
            ref={el => {
              this.dt = el;
            }}
            value={this.props.stationList}
            selectionMode="single"
            onSelectionChange={e => {
              this.props.crudlControl(CrudlStatus.UPDATE, e.data);
            }}
            header={
              <div className="ui-g">
                <div className="ui-g-12">
                  <pr.Button
                    type="button"
                    style={{
                      marginRight: ".25em",
                      float: "left",
                      background: this.props.buttonColour
                    }}
                    icon={
                      this.props.settingsToggle === ToggleState.OFF
                        ? "pi pi-cog"
                        : "pi pi-times"
                    }
                    onClick={e => {
                      if (this.props.settingsToggle === ToggleState.ON) {
                        console.log("SettingsToggle ==> OFF");
                        this.props.updateState(
                          "settingsToggle",
                          ToggleState.OFF
                        );
                      }
                      if (this.props.settingsToggle === ToggleState.OFF) {
                        console.log("SettingsToggle ==> ON");
                        this.props.updateState(
                          "settingsToggle",
                          ToggleState.ON
                        );
                      }
                    }}
                  />
                  <pr.Button
                    label={"Add New"}
                    icon="pi pi-plus"
                    style={{
                      marginRight: ".25em",
                      float: "right",
                      background: this.props.buttonColour
                    }}
                    onClick={() => {
                      this.props.crudlControl(CrudlStatus.CREATE);
                    }}
                  />
                  <pr.Button
                    type="button"
                    label={"Export Data"}
                    style={{
                      marginRight: ".25em",
                      float: "right",
                      background: this.props.buttonColour
                    }}
                    icon="pi pi-external-link"
                    onClick={this.export}
                  ></pr.Button>
                  <pr.Button
                    type="button"
                    style={{
                      marginRight: ".25em",
                      float: "right",
                      background: this.props.buttonColour
                    }}
                    label={"Refresh"}
                    icon={
                      this.props.loading === true
                        ? "pi pi-spin pi-spinner"
                        : "pi pi-refresh"
                    }
                    onClick={this.props.refresh}
                  ></pr.Button>
                </div>
              </div>
            }
            emptyMessage="No Stations"
            expandedRows={this.props.expandedRows}
            onRowToggle={e => this.props.updateState("expandedRows", e.data)}
            rowExpansionStation={this.getDisplayCard}
            rows={this.props.rowCount}
            autoLayout={true}
            paginator={true}
            alwaysShowPaginator={true}
            responsive={true}
            loading={this.props.loading}
          >
            {this.getStationColumns()}
          </pr.DataTable>
        </div>
      </React.Fragment>
    );
  }
  getDisplayCard = data => {
    return <ToolsDisplay data={data} onClick={this.props.crudlControl} />;
  };
}



// WEBPACK FOOTER //
// ./src/components/Tools/UI/ToolsTable.js